export const ALPHA_UI_SERVICE_NAMES = [
    'ALPHA_UI_ADMIN_SERVICE_URL',
    'ALPHA_UI_AUTH_SERVICE_URL',
    'ALPHA_UI_MODULE_SERVICE_URL',
    'ALPHA_UI_CASE_SERVICE_URL',
    'ALPHA_UI_CONFIG_SERVICE_URL',
    'ALPHA_UI_DASHBOARD_SERVICE_URL',
    'ALPHA_UI_VERSION_SERVICE_URL',
];

export const ALPHA_SERVICES_NAMES = [
    'ALPHA_ADMIN_SERVICE_URL',
    'ALPHA_AUTH_SERVICE_URL',
    'ALPHA_MODULE_SERVICE_URL',
    'ALPHA_CASE_SERVICE_URL',
    'ALPHA_CONFIG_SERVICE_URL',
    'ALPHA_DASHBOARD_SERVICE_URL',
    'ALPHA_VERSION_SERVICE_URL',
];
